<template>
    <ul class="menu-inner py-1">
        <li class="menu-item">
            <router-link to="/dashboard" class="menu-link">
                <i class="menu-icon tf-icons bx bx-home-circle"></i>
                <div>Dashboard</div>
            </router-link>
        </li>
        <li class="menu-item">
            <router-link to="/services" class="menu-link">
                <i class="menu-icon tf-icons bx bx-cog"></i>
                <div>Products/Services</div>
            </router-link>
        </li>
        <li class="menu-item">
            <router-link to="/billing" class="menu-link">
                <i class="menu-icon tf-icons bx bx-credit-card"></i>
                <div>Billing</div>
            </router-link>
        </li>
        <li class="menu-item">
            <router-link to="/invoices" class="menu-link">
                <i class="menu-icon tf-icons bx bx-receipt"></i>
                <div>Invoices</div>
            </router-link>
        </li>
        <li class="menu-item">
            <router-link to="/payments" class="menu-link">
                <i class="menu-icon tf-icons bx bx-dollar"></i>
                <div>Payment</div>
            </router-link>
        </li>

    </ul>
</template>

<script>
    export default {
        name: 'Sidebar',
    };
</script>

<style scoped>
    
</style>
